/**
 * Wild Network — canonical local/session storage key strings.
 * Legacy `wfn_*` keys are migrated at read sites via `migrateBrowserStorageKey` helpers.
 */
export const ANONYMOUS_ID_LOCAL_KEY = "wn_anonymous_id";
export const ANONYMOUS_ID_LOCAL_KEY_LEGACY = "wfn_anonymous_id";

export const PRECIP_ACCESS_PRIMED_PREFIX = "wn_precip_access_primed";

export const DETAILS_LIST_AI_SESSION_KEY = "wn_host_wizard_details_ai_generations";

export const GUEST_HOME_STATE_SESSION_KEY = "wn_guest_home_state";
export const GUEST_HOME_STATE_SESSION_KEY_LEGACY = "wfn_guest_home_state";

export const HOME_STATE_SESSION_MIRROR_PREFIX = "wn_home_state_session_";
export const HOME_STATE_SESSION_MIRROR_PREFIX_LEGACY = "wfn_home_state_session_";

export const USER_HOME_STATE_LOCAL_PREFIX = "wn_home_state";
export const USER_HOME_STATE_LOCAL_PREFIX_LEGACY = "wfn_home_state";

export const UPGRADE_SUCCESS_SESSION_KEY = "wn_upgrade_success";
export const UPGRADE_SUCCESS_SESSION_KEY_LEGACY = "wfn_upgrade_success";

/** Bump when species API payload shape must refresh (e.g. image URL generation). */
export const SPECIES_CACHE_SESSION_PREFIX = "wn_species_cache_v3_";
export const SPECIES_CACHE_SESSION_PREFIX_LEGACY = "wfn_species_cache_";

/** Session cache for GBIF/Wikipedia preview species profiles. */
export const SPECIES_PREVIEW_CACHE_SESSION_KEY = "wn_species_preview_cache_v1";

/** Map toolbar — recently searched species (LRU, newest first). */
export const MAP_RECENT_SPECIES_SEARCHES_KEY = "wn_map_recent_species_searches_v1";
